<template>
    <div class="main" v-if="isolate">
        <div class="header_margin">
            <span>
                <span class="site_label">Isolate File Number</span>
                <span class="site_value">
                    {{isolate.isolateNumber}}
                </span>
            </span>
            <span v-if="isolate.isolateCurationId">
                <span class="site_label">Isolate Curation Number</span>
                <span class="site_value">{{ isolate.isolateCurationId }}</span>
            </span>
            <span v-if="isolate.niRecId">
                <span class="site_label">NIRecId (Legacy) </span>
                <span class="site_value">{{ isolate.niRecId }}</span>
            </span>
            <span>
                <span class="site_label">County</span>
                <span class="site_value">
                    {{isolate.countyCodeList}}
                </span>
            </span>
        </div>
    </div>
</template>

<script>
import loggingService from '../services/util/loggingService'

export default {
    name: 'isolateHeader',
    props: {
        isolate: {}
    },
    data: function () {
        return {
            isDebug: false
        }
    },
    computed: {
    },
    created () {
        loggingService.log(this.isDebug, 'isolateHeader', 'created')
    },
    mounted () {
        loggingService.log(this.isDebug, 'isolateHeader', 'mounted')
    },
    methods: {
    }
}
</script>

<style>
    .main {
        padding: 10px;
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: 10px;
        border: 1px solid #cccccc;
        border-radius: 4px;
        background-color: #f5f5f5;
    }
    .site_label {
        margin-right: 20px;
        color: #555555;
        font-weight: normal;
    }
    .site_value {
        margin-right: 20px;
        font-weight: bold;
    }
    .header_margin {
        margin-bottom: 5px;
    }
</style>



// WEBPACK FOOTER //
// IsolateHeader.vue?54bf089b